import {
  MATOMO_ABANDON_ACTION,
  MATOMO_CUSTOM_DIMENSION,
  MATOMO_EVENT_CATEGORY,
  MATOMO_EVENT_TYPE,
  MATOMO_VIEW_ACTION,
} from '@/base/const/matomo.const'
import { ToolsClass } from '@/base/class/tools.class'

export class MatomoClass {
  /**
   * Wysłanie eventu do Matomo
   * @param {array} data
   */
  static sendEvent(data) {
    if (!window._paq) {
      window._paq = []
    }
    if (ToolsClass.isDebugEnabled()) {
      console.log('MatomoClass.sendEvent', JSON.stringify(data))
    }
    window._paq.push(data)
  }

  /**
   * Wysłanie eventu typu customDimension
   * @param {number} index
   * @param {any} value
   */
  static sendCustomDimension(index, value) {
    if (!window._paq) {
      window._paq = []
    }
    const data = [MATOMO_EVENT_TYPE.setCustomDimension, index, value]
    if (ToolsClass.isDebugEnabled()) {
      console.log('MatomoClass.sendCustomDimension', JSON.stringify(data))
    }
    window._paq.push(data)
  }

  /**
   * Wysłanie eventu trackPageView
   */
  static sendTrackPageView() {
    if (!window._paq) {
      window._paq = []
    }
    const data = [MATOMO_EVENT_TYPE.trackPageView]
    if (ToolsClass.isDebugEnabled()) {
      console.log('MatomoClass.sendCustomDimension', JSON.stringify(data))
    }
    window._paq.push(data)
  }

  /**
   * Wysłanie eventu porzucenia transakcji na widoku paywalla
   * (zamknięcie karty / powrót do sklepu bez realizacji płatności).
   * Poprzedzone custom dimensions identyfikującymi transakcję.
   * @param {string|number} serviceID
   * @param {string} apiToken
   * @param {string|number} orderId
   */
  static sendAbandonTransactionEvent(serviceID, apiToken, orderId) {
    this.sendCustomDimension(MATOMO_CUSTOM_DIMENSION.sid, serviceID)
    this.sendCustomDimension(MATOMO_CUSTOM_DIMENSION.sessionId, apiToken)
    this.sendCustomDimension(MATOMO_CUSTOM_DIMENSION.orderId, orderId)
    this.sendEvent([
      MATOMO_EVENT_TYPE.trackEvent,
      MATOMO_EVENT_CATEGORY.abandonTransaction,
      MATOMO_ABANDON_ACTION.view,
      MATOMO_VIEW_ACTION.paywall,
    ])
  }

  /**
   * Funckja sprawdzająca załadowanie skryptu Matomo
   * @returns {boolean}
   */
  static isMatomoLoaded() {
    return window.Matomo && window.Matomo.initialized === true
  }
}
